/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AuditDropshipApplicationRequest,
    CheckDropshipEligibilityResponse,
    FetchUserSubscriptionLevelRequest,
    FetchUserSubscriptionLevelResponse,
    GetDropshipApplicationResponse,
    GetOnboardingContestSubmissionResponse,
    PickOnboardingContestWinnerRequest,
    RefreshUserSubscriptionLevelRequest,
    SubmitDropshipApplicationRequest,
} from '../models';

export interface PopStoreCreatorApiControllerAuditDropshipApplicationRequest {
    creatorId: string;
    applicationId: string;
    auditDropshipApplicationRequest: AuditDropshipApplicationRequest;
}

export interface PopStoreCreatorApiControllerCheckDropshipEligibilityRequest {
    creatorId: string;
}

export interface PopStoreCreatorApiControllerFetchUserSubscriptionLevelRequest {
    creatorId: string;
    fetchUserSubscriptionLevelRequest: FetchUserSubscriptionLevelRequest;
}

export interface PopStoreCreatorApiControllerGetDropshipApplicationRequest {
    creatorId: string;
}

export interface PopStoreCreatorApiControllerGetOnboardingContestSubmissionRequest {
    creatorId: string;
}

export interface PopStoreCreatorApiControllerPickOnboardingContestWinnerRequest {
    creatorId: string;
    submissionId: string;
    pickOnboardingContestWinnerRequest: PickOnboardingContestWinnerRequest;
}

export interface PopStoreCreatorApiControllerRefreshUserSubscriptionLevelRequest {
    userId: string;
    refreshUserSubscriptionLevelRequest: RefreshUserSubscriptionLevelRequest;
}

export interface PopStoreCreatorApiControllerRegenerateDefaultScreenshotRequest {
    creatorId: string;
    submissionId: string;
}

export interface PopStoreCreatorApiControllerSubmitDropshipApplicationRequest {
    creatorId: string;
    submitDropshipApplicationRequest: SubmitDropshipApplicationRequest;
}

export interface PopStoreCreatorApiControllerSubmitOnboardingContestRequest {
    creatorId: string;
}

/**
 * 
 */
export class PopStoreCreatorApi extends runtime.BaseAPI {

    /**
     */
    async popStoreCreatorApiControllerAuditDropshipApplicationRaw(requestParameters: PopStoreCreatorApiControllerAuditDropshipApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerAuditDropshipApplication.');
        }

        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling popStoreCreatorApiControllerAuditDropshipApplication.');
        }

        if (requestParameters.auditDropshipApplicationRequest === null || requestParameters.auditDropshipApplicationRequest === undefined) {
            throw new runtime.RequiredError('auditDropshipApplicationRequest','Required parameter requestParameters.auditDropshipApplicationRequest was null or undefined when calling popStoreCreatorApiControllerAuditDropshipApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}/dropship-applications/{applicationId}:audit`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))).replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.auditDropshipApplicationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerAuditDropshipApplication(requestParameters: PopStoreCreatorApiControllerAuditDropshipApplicationRequest): Promise<void> {
        await this.popStoreCreatorApiControllerAuditDropshipApplicationRaw(requestParameters);
    }

    /**
     */
    async popStoreCreatorApiControllerCheckDropshipEligibilityRaw(requestParameters: PopStoreCreatorApiControllerCheckDropshipEligibilityRequest): Promise<runtime.ApiResponse<CheckDropshipEligibilityResponse>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerCheckDropshipEligibility.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}:check-dropship-eligibility`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerCheckDropshipEligibility(requestParameters: PopStoreCreatorApiControllerCheckDropshipEligibilityRequest): Promise<CheckDropshipEligibilityResponse> {
        const response = await this.popStoreCreatorApiControllerCheckDropshipEligibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async popStoreCreatorApiControllerFetchUserSubscriptionLevelRaw(requestParameters: PopStoreCreatorApiControllerFetchUserSubscriptionLevelRequest): Promise<runtime.ApiResponse<Array<FetchUserSubscriptionLevelResponse>>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerFetchUserSubscriptionLevel.');
        }

        if (requestParameters.fetchUserSubscriptionLevelRequest === null || requestParameters.fetchUserSubscriptionLevelRequest === undefined) {
            throw new runtime.RequiredError('fetchUserSubscriptionLevelRequest','Required parameter requestParameters.fetchUserSubscriptionLevelRequest was null or undefined when calling popStoreCreatorApiControllerFetchUserSubscriptionLevel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}/user-subscription-level`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.fetchUserSubscriptionLevelRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async popStoreCreatorApiControllerFetchUserSubscriptionLevel(requestParameters: PopStoreCreatorApiControllerFetchUserSubscriptionLevelRequest): Promise<Array<FetchUserSubscriptionLevelResponse>> {
        const response = await this.popStoreCreatorApiControllerFetchUserSubscriptionLevelRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async popStoreCreatorApiControllerGetDropshipApplicationRaw(requestParameters: PopStoreCreatorApiControllerGetDropshipApplicationRequest): Promise<runtime.ApiResponse<GetDropshipApplicationResponse>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerGetDropshipApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}:get-dropship-application`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerGetDropshipApplication(requestParameters: PopStoreCreatorApiControllerGetDropshipApplicationRequest): Promise<GetDropshipApplicationResponse> {
        const response = await this.popStoreCreatorApiControllerGetDropshipApplicationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async popStoreCreatorApiControllerGetOnboardingContestSubmissionRaw(requestParameters: PopStoreCreatorApiControllerGetOnboardingContestSubmissionRequest): Promise<runtime.ApiResponse<GetOnboardingContestSubmissionResponse>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerGetOnboardingContestSubmission.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}/get-onboarding-contest-submission`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerGetOnboardingContestSubmission(requestParameters: PopStoreCreatorApiControllerGetOnboardingContestSubmissionRequest): Promise<GetOnboardingContestSubmissionResponse> {
        const response = await this.popStoreCreatorApiControllerGetOnboardingContestSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async popStoreCreatorApiControllerPickOnboardingContestWinnerRaw(requestParameters: PopStoreCreatorApiControllerPickOnboardingContestWinnerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerPickOnboardingContestWinner.');
        }

        if (requestParameters.submissionId === null || requestParameters.submissionId === undefined) {
            throw new runtime.RequiredError('submissionId','Required parameter requestParameters.submissionId was null or undefined when calling popStoreCreatorApiControllerPickOnboardingContestWinner.');
        }

        if (requestParameters.pickOnboardingContestWinnerRequest === null || requestParameters.pickOnboardingContestWinnerRequest === undefined) {
            throw new runtime.RequiredError('pickOnboardingContestWinnerRequest','Required parameter requestParameters.pickOnboardingContestWinnerRequest was null or undefined when calling popStoreCreatorApiControllerPickOnboardingContestWinner.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}/onboarding-contest-submissions/{submissionId}:pick-winner`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))).replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters.submissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.pickOnboardingContestWinnerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerPickOnboardingContestWinner(requestParameters: PopStoreCreatorApiControllerPickOnboardingContestWinnerRequest): Promise<void> {
        await this.popStoreCreatorApiControllerPickOnboardingContestWinnerRaw(requestParameters);
    }

    /**
     */
    async popStoreCreatorApiControllerRefreshUserSubscriptionLevelRaw(requestParameters: PopStoreCreatorApiControllerRefreshUserSubscriptionLevelRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling popStoreCreatorApiControllerRefreshUserSubscriptionLevel.');
        }

        if (requestParameters.refreshUserSubscriptionLevelRequest === null || requestParameters.refreshUserSubscriptionLevelRequest === undefined) {
            throw new runtime.RequiredError('refreshUserSubscriptionLevelRequest','Required parameter requestParameters.refreshUserSubscriptionLevelRequest was null or undefined when calling popStoreCreatorApiControllerRefreshUserSubscriptionLevel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-user/{userId}/refresh-user-subscription-level`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.refreshUserSubscriptionLevelRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerRefreshUserSubscriptionLevel(requestParameters: PopStoreCreatorApiControllerRefreshUserSubscriptionLevelRequest): Promise<void> {
        await this.popStoreCreatorApiControllerRefreshUserSubscriptionLevelRaw(requestParameters);
    }

    /**
     */
    async popStoreCreatorApiControllerRegenerateDefaultScreenshotRaw(requestParameters: PopStoreCreatorApiControllerRegenerateDefaultScreenshotRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerRegenerateDefaultScreenshot.');
        }

        if (requestParameters.submissionId === null || requestParameters.submissionId === undefined) {
            throw new runtime.RequiredError('submissionId','Required parameter requestParameters.submissionId was null or undefined when calling popStoreCreatorApiControllerRegenerateDefaultScreenshot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}/onboarding-contest-submissions/{submissionId}:regenerate-default-screenshot`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))).replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters.submissionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerRegenerateDefaultScreenshot(requestParameters: PopStoreCreatorApiControllerRegenerateDefaultScreenshotRequest): Promise<void> {
        await this.popStoreCreatorApiControllerRegenerateDefaultScreenshotRaw(requestParameters);
    }

    /**
     */
    async popStoreCreatorApiControllerSubmitDropshipApplicationRaw(requestParameters: PopStoreCreatorApiControllerSubmitDropshipApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerSubmitDropshipApplication.');
        }

        if (requestParameters.submitDropshipApplicationRequest === null || requestParameters.submitDropshipApplicationRequest === undefined) {
            throw new runtime.RequiredError('submitDropshipApplicationRequest','Required parameter requestParameters.submitDropshipApplicationRequest was null or undefined when calling popStoreCreatorApiControllerSubmitDropshipApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}:submit-dropship-application`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.submitDropshipApplicationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerSubmitDropshipApplication(requestParameters: PopStoreCreatorApiControllerSubmitDropshipApplicationRequest): Promise<void> {
        await this.popStoreCreatorApiControllerSubmitDropshipApplicationRaw(requestParameters);
    }

    /**
     */
    async popStoreCreatorApiControllerSubmitOnboardingContestRaw(requestParameters: PopStoreCreatorApiControllerSubmitOnboardingContestRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.creatorId === null || requestParameters.creatorId === undefined) {
            throw new runtime.RequiredError('creatorId','Required parameter requestParameters.creatorId was null or undefined when calling popStoreCreatorApiControllerSubmitOnboardingContest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popstore-creator/{creatorId}:submit-onboarding-contest`.replace(`{${"creatorId"}}`, encodeURIComponent(String(requestParameters.creatorId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async popStoreCreatorApiControllerSubmitOnboardingContest(requestParameters: PopStoreCreatorApiControllerSubmitOnboardingContestRequest): Promise<void> {
        await this.popStoreCreatorApiControllerSubmitOnboardingContestRaw(requestParameters);
    }

}
